import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine2Font4xl extends ITextBoxProps {}

export const TextBoxMaxLine2Font4xl = ({
  title,
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Font4xlBold,
  alignment = TextAligning.Left,
  maxLines = 2,
  ...rest
}: ITextBoxMaxLine2Font4xl): JSX.Element => {
  return (
    <TextBox
      title={title}
      color={color}
      font={font}
      alignment={alignment}
      maxLines={maxLines}
      {...rest}
    />
  )
}
